export enum RequestWhileCriterionType {
  USER_CUSTOM_STATUS = 'USER_CUSTOM_STATUS',
  USER_DEMOGRAPHIC_VALUE = 'USER_DEMOGRAPHIC_VALUE',
}
